<template>
  <div class="widget-list" style="width: -webkit-fill-available;">
    <div class="typo-littleblack"><i class="fas fa fa-1x fa-clock-o mr-2"></i>Timezone location: {{this.$store.state.timezoneLocation}}</div>
    <b-table
      class="widget-table"
      :items="reportItems"
      :fields="reportTestFields"
      :state="lastSortedLogbook"
    >

      <template v-slot:cell(evEsito)="{ item: item }">
        <i :class="['fa ' +item.evEsito, 'my-auto']"></i>
      </template>
      <template v-slot:cell(dataEv)="{ item: item }">
        <strong>{{item.dataEv.split("\n")[0]}}</strong>
        <br />
        {{item.dataEv.split("\n")[1]}}
      </template>
      <template v-slot:cell(evDesc)="{ item: item }">
          <DownloadPdfBleReport :report="getReport(item)" :plant="$store.state.currentPlant"></DownloadPdfBleReport>
          <!-- router-link class="noborder-button download" :to="{path: '/blereport/'+ getReport(item).plantId +'/'+ item.timestamp}"><i class="fas fa fa-1x fa-download mr-2"></i>Download</router-link> --->

      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DownloadPdfBleReport from "./DownloadPdfBleReport.vue";

export default {
  name: "reportBleOverview",
  components:{
    DownloadPdfBleReport
  },
  data() {
    return {
      reportItems: [],
      reportTestFields: [
        { key: "dataEv", label: this.$t("cards.date_report") },
        { key: "evEsito", label: this.$t("cards.result"), tdClass: "text-center align-middle" },
        { key: "evDesc", label: this.$t("cards.title_report"), tdClass: "align-middle" }
      ]
    };
  },
  computed: {
    lastSortedLogbook() {
      //filtra i logbook relativi esclusivamente a test funzionali e di autonomia
      var sortedLogbook = this.$store.state.bleLogbooks.filter(function(
        item
      ) {
        return (
          item.log_type != "assenza_rete" && item.log_type != "rientro_rete" && item.log_type!="vuoto"
        );
      });
      //ordina i logbook per data partendo dalla data più recente
      sortedLogbook.sort(function(a, b) {
        return b.timestamp - a.timestamp;
      });
      //inserisce i dati negli items della tabella con ultimi test
      let icon_esito = "";
      let formatted_date = "";
      let formatted_logtype = "";
      let last_number_of_test = 10;
      this.reportItems = [];
      if (sortedLogbook.length < last_number_of_test)
        last_number_of_test = sortedLogbook.length;
      for (var i = 0; i < last_number_of_test; i++) {
        if (sortedLogbook[i].log_esito == "pass")
          icon_esito = "fa-circle success";
        else icon_esito = "fa-circle danger";

        //var dateObj = new Date(sortedLogbook[i].log_timestamp * 1000);
        var dateObj = new Date(sortedLogbook[i].log_date);
        formatted_date = 
          dateObj.toLocaleDateString() +
          "\n" +
          dateObj.toLocaleTimeString();
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.reportItems.push({
          dataEv: formatted_date,
          evEsito: icon_esito,
          timestamp: sortedLogbook[i].timestamp
        });
      }
      console.log("lastSortedLogbook: ", this.reportItems);
    }
  },
  methods:{
      getReport(report)
      {
        console.log("get report",report);
        return this.$store.state.bleLogbooks.filter(function(item)
            {
              if (item.timestamp == report.timestamp) return true;
            })[0];
      }
    }
}
</script>